module.exports = __webpack_public_path__ + "img/a8ac297c72dd9911180d1be66c93888a.png";